import { TicketSampleFormType } from 'components/ticket-samples/TicketSampleForm';

export const updateTicketSampleInitialValues: Partial<TicketSampleFormType> = {};
